import { styled, TableContainer, TableHead } from "@mui/material";

export const CustomTableContainer = styled(TableContainer)({
  maxHeight: "400px",
  overflowX: "auto",
  overflowY: "auto",
  width: "100%",
  border: "none",
  boxShadow: "none",
  padding: "0",
  "&::-webkit-scrollbar": {
    width: "0px",
    height: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#ADD8E6",
    borderRadius: "15px",
    transform: "scaleX(0.5)",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "#87CEEB",
  },
});

export const tableCellStyle = {
  fontFamily: "Raleway",
  fontSize: "14px",
  fontWeight: 700,
  lineHeight: "16.44px",
  textAlign: "center",
  color: "#999999",
  minWidth: "150px",
};

export const tableCellStyle1 = {
  textAlign: "center",
};

export const CustomTableHead = styled(TableHead)({
  "& .MuiTableCell-root": {
    borderBottom: "none",
  },
});
